import React, { useEffect, useState } from 'react';
import {
 Chart as ChartJS,
 CategoryScale,
 LinearScale,
 BarElement,
 PointElement,
 LineElement,
 Title,
 Tooltip,
 Legend
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Bar, Chart } from "react-chartjs-2";
ChartJS.register(
 CategoryScale,
 LinearScale,
 BarElement,
 PointElement,
 LineElement,
 Title,
 Tooltip,
 Legend,
 ChartDataLabels
);
import {
    Card,
    CardBody,
    CardTitle,
    Col,
    Row,
    CardHeader,
    Button,
    Nav,
    NavItem,
    NavLink,
} from 'reactstrap';
import ErrorBoundary from 'components/ErrorBoundary';
import Drawer from 'components/Drawer';
import DrugTypeAnalysisDrawer from '../GridData/DrugTypeAnalysisDrawer';
const DrugTypeAnalysis  = ({data,searchData}) => {

        const [isOpen, setIsOpen] = useState(false);
        const [disabledViewButtom, setDisabledViewButtom] = useState(true);
    
    useEffect(() => {
      if (data[0] != null ){
        setDisabledViewButtom(false);
      } else {
        setDisabledViewButtom(true);
      }
    }, [data]);

  const chartData = {

labels:  data[0]?.labels,
   datasets: [
     {
       type: 'bar',
       label: 'SSB',
       data:data[0]?.ssbCounts,
       backgroundColor: "#702C62", // Purple color
       borderColor:"#702C62",
       borderWidth: 1,

     },
     {
       type: 'bar',
       label: 'MSB',
       data: data[0]?.msbCounts,
       backgroundColor: '#e0dbdbff',
       borderColor:'#e0dbdbff',
       borderWidth: 1,
     },
      {
       type: 'bar',
       label: 'Generic',
       data: data[0]?.genericCount,
       backgroundColor:  '#B54DA0',
       borderColor:  '#B54DA0',
       borderWidth: 1,
     },

   ],
 };

 const options = {
   responsive: true,
   plugins: {
     legend: {
       position: 'bottom',
           labels: {
                        padding: 15,
                        usePointStyle: true,
                        pointStyle: 'rect',
                        color: '#707070',
                        font: {
                            weight: 'bold',
                        },
                    },
                      align: 'start',
     },
     title: {
       display: true,
      // text: 'Drug Type Analysis',
     },
   datalabels:{
    display:false,
     },
       tooltip: {
        mode: 'index',
        intersect: false,
      
    //         anchor:'start',
    //  align:'end'

  },
     formatter:(value,context)=>{
        if(context.dataset.type=='bar'){
            return value;
        }
        return null
     },
    //  anchor:'start',
    //  align:'end',
   },
   scales: {
    x:{
        stacked:true
    },
     y: {
       beginAtZero: true,
     },
   },
 };

 const handleActive = (title) => {
        setActive(title);
    };
    const getDate = () => {
        setActive('custom')
    }
    const handleProceed = () => {
        setIsOpen(!isOpen);
    }
    const onHandleIsOpen = (hasRefresh) => {
        if (isBoolean(hasRefresh) && hasRefresh) {
            onClose(true);
        }
        setIsOpen(!isOpen)
    }
 return (
    <div>
      <ErrorBoundary>
            <Card className='p-3 h-100'>
                 <CardHeader className='border-0 bg-white px-0 pt-0'>
                   <Row className="align-items-center">
                    <Col>
                     <CardTitle className="f-20 font-weight-500">Drug Type Analysis </CardTitle>
                 
                
                    </Col>
                    </Row>
                       </CardHeader>

            <CardBody className='dashboard-chart-body'>
             
             <Bar  data={chartData} options={options} />
              <div className="view-report">
                                     <Button
                                         color='primary'
                                         className='ms-2'
                                         onClick={handleProceed}
                                        style={{ float: "right", position: "absolute", bottom: "3px", right: "30px"}}
                                         disabled={disabledViewButtom}
                                     >
                                         View Report
                                     </Button>
                                     </div>
            </CardBody>
          </Card>
         <Drawer
                direction='end'
                title='Drug Type Analysis'
                isOpen={isOpen}
                toggle={handleProceed}
                size="lg"
            >
                <DrugTypeAnalysisDrawer searchData={searchData}  onHandleIsOpen={onHandleIsOpen}  />
            </Drawer> 
          </ErrorBoundary>
    </div>
 )
}
export default  DrugTypeAnalysis;